// SSIRegistration.jsx
import React from "react";

export default function SSIRegistration() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            SSI Registration
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            Small Scale Industries (SSI) Registration in India
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks assists businesses in SSI Registration for
            formal recognition and compliance, helping small units align with
            MSME norms and access government-linked benefits and schemes.
          </p>
          <p className="text-gray-700">
            From understanding eligibility and preparing core details to
            organizing documentation and online application, the process is
            handled in a clear and structured manner so you can focus on running
            your enterprise.
          </p>
        </div>

        {/* Right: Image (different, square) */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/3737366/pexels-photo-3737366.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Small scale industry team working in office"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required for SSI Registration
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks helps collate and structure the key details
              needed for SSI/ MSME registration so applications are complete and
              consistent with portal requirements.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>PAN card of the business or proprietor/partners/directors, as applicable.</li>
                <li>
                  Basic business address proof (office/plant address – utility
                  bill, rent agreement or ownership document).
                </li>
                <li>
                  Bank account details of the business (account number, IFSC and
                  basic bank information).
                </li>
                <li>
                  Aadhaar and contact details of the applicant and key
                  promoters, wherever required.
                </li>
                <li>
                  Basic business information such as activity type, number of
                  employees, and investment details, if sought in the form.
                </li>
                <li>
                  Any additional declarations or attachments required on the
                  registration portal, depending on the nature of the unit.
                </li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              The firm provides practical and process-oriented guidance to small
              businesses, helping them complete SSI registration accurately and
              without unnecessary delays.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Clear Compliance Guidance
                </h3>
                <p className="text-gray-700 text-sm">
                  Step-wise support on how to approach SSI/MSME registration,
                  what details are required, and how they should match official
                  records.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Accurate Documentation
                </h3>
                <p className="text-gray-700 text-sm">
                  Assistance in aligning documents, business details, and bank
                  information with the registration form to avoid mismatches and
                  follow-up queries.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Professional Assistance
                </h3>
                <p className="text-gray-700 text-sm">
                  Professional, responsive support throughout the registration
                  journey, offering clarity on doubts and helping complete the
                  process efficiently.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
